import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';
import BoxAPI from '../services/box.api.service';
import LotAPI from '../services/lot.api.service';
import useAlert from './Alert/useAlert';
import { QrCode } from './QrCode';

export const BoxSelector = ({customer, onBoxChange, selectedBox, boxStatus, searchByLotCustomer = false}) => {
    const {showErrorAlert} = useAlert();
    const [state, setState] = useState({
        loading: false,
        lots: [],
        selectedLot: null,
        boxes: [],
    });

    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));

    useEffect(() => {customer && loadLots()}, [customer]);
    useEffect(() => {state.selectedLot ? loadBoxes() : changeState({boxes: []})},[state.selectedLot, selectedBox]);

    const loadLots = () => {
        changeState({loading: true});
        LotAPI
            .getLots(searchByLotCustomer ? {customer: customer.id} : {boxCustomer: customer.id})
            .then(result => changeState({lots: result.items}))
            .catch((err) => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}));
    };

    const loadBoxes = () => {
        changeState({loading: true})
        BoxAPI
            .getBoxes({
                lot: state.selectedLot.id,
                status: boxStatus,
                customer: searchByLotCustomer ? null : customer.id,
                lotCustomer: searchByLotCustomer ? customer.id : null,
            })
            .then(result => changeState({boxes: result.items}))
            .catch((err) => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}));
    };

    const handleChangeBox = (event, value) => onBoxChange(value);

    return (
        <div>
            <Autocomplete
                disabled={!customer}
                sx={{mb: 1, mt: 1}}
                options={state.lots}
                getOptionLabel={(option) => option.name || ''}
                id="lotName"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, value) => changeState({selectedLot: value})}
                renderOption={(props, option) => <li {...props} key={option.id}>{option.name}</li>}
                renderInput={params => (
                    <TextField
                        required
                        {...params}
                        label="NFTProductName"
                        variant="standard"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {state.loading ? <CircularProgress color="inherit" size={20}/> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
            <Autocomplete
                sx={{mb: 2, mt: 1}}
                options={state.boxes}
                value={selectedBox}
                getOptionLabel={(option) => option.hash || ''}
                id="hash"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={handleChangeBox}
                disabled={!state.selectedLot}
                renderInput={params => <TextField required {...params} label="NFTBox" variant="standard"/>}
            />

            {selectedBox && <QrCode hash={selectedBox.hash}/>}
        </div>
    );
};
